import React, { useEffect, useState } from 'react';
import { useCommonStyles } from '../../materialConfig/commonStyles';
import { BaseTypography } from "src/components/common";
import { makeStyles } from "@material-ui/core/styles";
import ImageOrVideo from '../../components/common/ImageOrVideo/ImageOrVideo';
import { GuestDiscuss } from './GuestDiscuss';
import { Grid } from '@material-ui/core';
import { getFullName } from '../../utils/helpers';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';

type PInterviewCarousel = {
    list: any;
};

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '60px 20px'
    },
    image:{
        maxWidth: '100% !important',
        '& iframe, video': {
            maxWidth: '100% !important',
          },
    },
    text: {
        margin: "20px 0 10px"
    },
    expertise: {
        display: "flex",
        gap: "10px",
        alignItems: "center",
    },
    website:{
        margin: "20px 0 10px"
    }
}));

export const Blog: React.FC<PInterviewCarousel> = (props) => {
    const { list } = props;
    const [expertise, setExpertise] = useState([]);
    const commonClasses = useCommonStyles();
    const classes = useStyles();    

    useEffect(() => {
        const expert:any = list.data.expertise.map((exp: any)=>{
           return list.expertise[exp];
        })
        setExpertise(expert);
        
        
    }, [list])

    

    return (
        <div className={`${commonClasses.container} ${classes.root}`}>
            <Grid
                container
                spacing={5}
            >
            <Grid item xs={12} md={8}>
				<BaseTypography gutterBottom="true" color="primary"><a href="/allposts" rel="noreferrer">All News</a></BaseTypography>
                <BaseTypography gutterBottom="true" variant="h2">{list?.data?.title}</BaseTypography>
                <BaseTypography gutterBottom="true" color="primary">Publish Date: {new Date(list?.data?.updated_at).toDateString().split(" ").splice(1, 4).join(" ")}</BaseTypography>
                {list?.data?.picture && (
                    <ImageOrVideo className={classes.image} src={list?.data.picture} alt={list?.data.picture} width="100% !important"/>
                )}
                <BaseTypography className={classes.text} dangerouslySetInnerHTML={{ __html :list?.data.text}} />
				{ /* <BaseTypography className={classes.text} variant="h4" color="primary">Expertise</BaseTypography>
                
                <Grid container spacing={1}>
                    {expertise?.map((exp:any)=>(
                        <Grid item xs={12} md={6}>
                            <div className={classes.expertise}>
                                <CheckCircleRoundedIcon fontSize="small" color="primary" />
                                <BaseTypography>{exp}</BaseTypography>
                            </div>
                        </Grid>
                    ))}
				</Grid> */ }
				{list?.data?.link && (
					<>
						<BaseTypography className={classes.website} variant="h4" color="primary">Website</BaseTypography>
						<BaseTypography>
							<a href={list?.data.link} target="_blank" rel="noreferrer">
								{list?.data.link}
							</a>
						</BaseTypography>
					</>
				)}
            </Grid>
            <Grid item xs={12} md={4}>
                <BaseTypography gutterBottom="true" variant="h3" color="primary">Suggested guest to discuss this story:</BaseTypography>
                {list?.data.guests?.map((guest: any) => (
                    <GuestDiscuss
                        key={guest.guest_id}
                        avatarSrc={guest.avatar}
                        guestId={guest.guest_id}
                        fullName={getFullName(guest)}
                    />
                ))}
                
            </Grid>
                
            </Grid>
        </div>
    )
}